import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var CurrencyCell = function (_a) {
    var cell = _a.cell;
    return _jsx("p", { children: "$".concat(cell.value) }, void 0);
};
export default CurrencyCell;
